import { TasksQueueInfiniteView } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components/tasks-queue-infinite'
import { TasksQueueTableView } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components/tasks-queue-table'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'

interface IProps {
  taskGroupId?: number
}

export const TasksQueueView: React.FC<IProps> = ({ taskGroupId }) => (
  <MobileViewSwitcher
    desktopView={<TasksQueueTableView taskGroupId={taskGroupId} />}
    mobileView={<TasksQueueInfiniteView taskGroupId={taskGroupId} />}
  />
)
